import * as React from "react"
import styled, { css } from "styled-components"
import { variants } from "../../styles/constants/typography"
import { typography } from "../../styles/styled-system"
import { scale, fontWeight, colors, breakpoints } from "../../styles"
import { ResponsiveValue, variant } from "styled-system"
import { ButtonNavyStyles, ButtonStyles, ButtonSizeNormalStyles } from ".."
import { INNER_MAX_WIDTH } from "../.."
import { DataLayer } from "@piwikpro/react-piwik-pro"


export interface RteProps {
	as?: any
	truncate?: ResponsiveValue<"singleLine" | "twoLine" | "threeLine" | "none">
	onClick?: () => void
	children?: React.ReactNode
}

const ButtonRte = css`
	${ButtonStyles}
	${ButtonNavyStyles}
	${ButtonSizeNormalStyles}
`

export const RteStyled = styled.article`
	h1 {
		${({ theme }) =>
		typography({
			...variants["headline-1"],
			theme,
			fontSize: { _: 4, m: 8 },
			lineHeight: { _: 4, m: 8 },
			mb: 2,
		})}
	}
	h2 {
		${({ theme }) =>
		typography({
			...variants["headline-2"],
			theme,
			fontSize: { _: 3, l: 4 },
			lineHeight: { _: 3, l: 4.5 },
			mb: 1.5,
		})}
	}
	h3 {
		${({ theme }) =>
		typography({
			...variants["headline-3"],
			theme,
			fontSize: { m: 2.5 },
			lineHeight: { m: 3 },
			mb: 1,
		})}
	}
	h4 {
		${({ theme }) =>
		typography({
			...variants["headline-4"],
			theme,
			fontSize: { m: 2 },
			lineHeight: { m: 2.5 },
			mb: 0.5,
		})}
	}
	p {
		${({ theme }) =>
		typography({
			...variants["paragraph-16"],
			theme,
		})}
	}
	a {
		${({ theme }) =>
		typography({
			theme,
		})}
		text-decoration: underline;

		:hover {
			color: ${colors.hoverBlue};
		}
	}
	em {
		font-style: italic;
	}
	strong {
		font-weight: ${fontWeight.bold};
	}
	ul,
	ol,
	dl {
		padding-left: ${scale.px(4)};
		margin-bottom: ${scale.px(4)};
	}
	ul li {
		list-style-type: disc;
	}
	ol li {
		list-style: decimal;
	}
	li {
		margin-bottom: ${scale.px(2)};
		list-style-position: outside;
		line-height: ${scale.px(3)};
	}
	img {
		margin-bottom: ${scale.px(3)};
	}
	.button {
		${ButtonRte}

		&:hover {
			color: ${colors.white};
		}
	}

	blockquote {
		display: flex;
		margin: auto;
		margin-bottom: ${scale.px(7)};
		margin-top: ${scale.px(4)};
		align-items: center;
		gap: ${scale.px(3)};

		p {
			${({ theme }) =>
		typography({
			...variants["quote"],
			theme,
		})}
			flex-grow: 1;
			background-image: url("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI2LjMuMSwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAzMC42OSAyNC45NyIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMzAuNjkgMjQuOTc7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDojMEQzMDUwO30KPC9zdHlsZT4KPHBhdGggY2xhc3M9InN0MCIgZD0iTTEzLjA5LDguMzZDMTMuMDksMi45Nyw5Ljc5LDAsNi4xNiwwYy0zLjMsMC01LjgzLDIuNzUtNS44Myw1Ljk0YzAsMy4zLDIuMiw1LjYxLDUuMjgsNS42MQoJYzAuNTUsMCwxLjMyLTAuMTEsMS41NC0wLjIyQzYuNzEsMTQuODUsMy41MiwxOS4yNSwwLDIxLjU2bDQuMDcsMy40MUM5LjEzLDIxLjM0LDEzLjA5LDE1LjA3LDEzLjA5LDguMzYgTTMwLjY5LDguMzYKCWMwLTUuMzktMy4zLTguMzYtNi45My04LjM2Yy0zLjE5LDAtNS44MywyLjc1LTUuODMsNS45NGMwLDMuMywyLjMxLDUuNjEsNS4zOSw1LjYxYzAuNDQsMCwxLjIxLTAuMTEsMS40My0wLjIyCgljLTAuNDQsMy41Mi0zLjUyLDcuOTItNy4wNCwxMC4yM2w0LjA3LDMuNDFDMjYuNzMsMjEuMzQsMzAuNjksMTUuMDcsMzAuNjksOC4zNiIvPgo8L3N2Zz4K");
			background-repeat: no-repeat;
			background-position: center 10px;
			background-size: ${scale.px(4)} auto;
			text-align: center;
			padding-top: ${scale.px(7)};
			max-width: ${scale.px(INNER_MAX_WIDTH / 2)};
			min-width: calc(50% - 12px);
			margin: auto;
			font-weight: ${fontWeight.bold};

			strong {
				font-weight: ${fontWeight.normal};
			}

			em {
				display: block;
				font-size: ${scale.px(1.75)};
				margin-top: ${scale.px(2)};
				font-style: normal;
				font-weight: ${fontWeight.normal};
			}
		}

		img,
		.qbankmediawrapper {
			min-width: calc(50% - 12px);
			aspect-ratio: 3/4;
			object-fit: cover;
			min-height: 100%;
			margin-bottom: 0;
		}
	}
	.ul-checkmark {
		padding-left: 24px;
	}
	.ul-checkmark li {
		list-style-type: none;
		padding-left: 8px;
	}

	.ul-checkmark li:before {
		content: "\u2713";
		padding-right: 8px;
		margin-left: -20px;
	}

	.button-width {
		width: fit-content;
	}

	.button-width a {
		width: 100%;
	}

	@media screen and (max-width: ${scale.px(breakpoints.m / 8)}) {
		blockquote {
			flex-direction: column;
			margin-bottom: ${scale.px(6)};
			gap: ${scale.px(4)};

			p {
				background-size: ${scale.px(3.125)} auto;
				padding-top: ${scale.px(5)};
				em {
					margin-top: ${scale.px(1)};
				}
			}
			img,
			.qbankmediawrapper {
				min-width: 100%;
			}
		}
	}

	${variant({
			prop: "truncate",
			variants: {
				singleLine: {
					width: "100%",
					whiteSpace: "nowrap",
					overflow: "hidden",
					textOverflow: "ellipsis",
				},
				twoLine: {
					overflow: "hidden",
					display: "-webkit-box",
					"-webkit-line-clamp": "2",
					"-webkit-box-orient": "vertical",
					whiteSpace: "normal",
				},
				threeLine: {
					overflow: "hidden",
					display: "-webkit-box",
					"-webkit-line-clamp": "3",
					"-webkit-box-orient": "vertical",
					whiteSpace: "normal",
				},
				none: {
					overflow: "visisble",
					display: "inline",
					"-webkit-line-clamp": "none",
					"-webkit-box-orient": "initial",
					whiteSpace: "normal",
				},
			},
		})}
`

export const Rte: React.FC<RteProps> = (props) => {

	const ref = React.useRef<HTMLDivElement>(null)

	React.useEffect(() => {
		if (ref.current) {
			const links = ref.current.querySelectorAll('a')
			const handleClick = (link: HTMLAnchorElement) => {
				DataLayer.push({
					event: 'rte_link_click',
					rte_link_title: link.attributes['title']?.value ?? '',
					rte_link: link.href ?? ''
				})
			}
			links.forEach((link) => {
				link.addEventListener('click', () => handleClick(link))
				return () => link.removeEventListener('click', () => handleClick(link))
			})
		}
	}, [])



	return (
		<div >

			<RteStyled ref={ref} {...props} />
		</div>
	)
} 
